import React from "react";
import { Link } from "gatsby";
import LogoSvg from "images/main/logo.inline.svg";

const HomeLink: React.FC<{ url: string }> = ({ url }) => {
    return (
        <Link to={url} className="link-prominent" aria-label="Home">
            <LogoSvg />
        </Link>
    );
};

export default HomeLink;
